import router from '@/routes'
import store from '@/store'
import {Route} from 'vue-router'
import auth from '@/services/auth'
import {locale} from 'moment';

interface ICtx {
  sess?: string,
  userId?: string,
  ui_page?: any,
  ua?: string
}

export function ctx (): ICtx {
  let ctx: ICtx = {};
  if (auth.readToken()) {
    ctx.sess = auth.readToken() as string;
  }
  if (store.state.user.user && store.state.user.user.id) {
    ctx.userId = store.state.user.user.id;
  }
  ctx.ui_page = location.href
  ctx.ua = navigator.userAgent
  return ctx;
}